// extracted by mini-css-extract-plugin
module.exports = {"section__ads":"ads_section__ads__N8i6Y","section__ads_carousel":"ads_section__ads_carousel__CevbL","container_full_width":"ads_container_full_width__t8EXM"};